import { render } from "./ScrollTopButtonComp.vue?vue&type=template&id=0c1a8382&scoped=true&ts=true"
import script from "./ScrollTopButtonComp.vue?vue&type=script&lang=ts"
export * from "./ScrollTopButtonComp.vue?vue&type=script&lang=ts"

import "./ScrollTopButtonComp.vue?vue&type=style&index=0&id=0c1a8382&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\Code\\VSProjects\\modboxProject\\modbox\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c1a8382"]])

export default __exports__